export const usePwaInstall = () => {
  const deferredPrompt = useState<any>('deferredPrompt')
  const canInstall = useState<boolean>('pwaCanInstall')
  const installed = useState<boolean>('pwaInstalled')
  const isStandalone = useState<boolean>('pwaStandalone')
  const isIos = useState<boolean>('pwaIsIos')
  const showIosInstallGuide = useState<boolean>('pwaShowIosInstallGuide')
  const { $dismissIosInstallGuide } = useNuxtApp()

  const promptInstall = async () => {
    const dp = deferredPrompt.value
    if (!dp) return { outcome: 'unavailable' as const }

    dp.prompt()
    const choice = await dp.userChoice // { outcome: 'accepted' | 'dismissed' }
    // Reset so we don't prompt repeatedly
    deferredPrompt.value = null
    canInstall.value = false
    return choice
  }

  return {
    canInstall,
    installed,
    isStandalone,
    isIos,
    showIosInstallGuide,
    promptInstall,
    dismissIosInstallGuide: $dismissIosInstallGuide,
  }
}
